export function getRowColumn ({ element, cellWidth, cellHeight, topBorder, leftBorder }) {
  const coordinator = element.getCoordinator();
  const row = Math.floor(Math.ceil(coordinator.top - topBorder) / cellHeight);
  const column = Math.floor(Math.ceil(coordinator.left - leftBorder) / cellWidth);
  return { row, column };
}

export function isTheSameColumn (element1, element2) {
  return !(element1.getCoordinator().getRight() <= element2.getCoordinator().left ||
  element1.getCoordinator().left >= element2.getCoordinator().getRight());
}

export function isTheSameRow (element1, element2) {
  return !(element1.getCoordinator().getBottom() <= element2.getCoordinator().top ||
  element1.getCoordinator().top >= element2.getCoordinator().getBottom());
}

export function getTheMostOccurringNumber (numbers) {
  if (numbers.length === 0) return null;

  const valuesOccurrence = numbers.reduce((occurrences, gap) => {
    if (!occurrences[gap]) {
      occurrences[gap] = 0;
    }
    occurrences[gap]++;
    return occurrences;
  }, {});

  return Number(numbers.reduce((currentMostOccurringValue, value) => valuesOccurrence[currentMostOccurringValue] > valuesOccurrence[value] ? currentMostOccurringValue : value));
}

export function computeRowsAndColumnsAfterTidying (smartSelectGroup) {
  let numColumns = smartSelectGroup.getNumberOfColumns();
  let numRows = smartSelectGroup.getNumberOfRows();

  const totalSlots = numColumns * numRows;

  if (totalSlots < smartSelectGroup.getElements().length) {
    const numRemainingElements =
      smartSelectGroup.getElements().length - totalSlots;
    if (numColumns > numRows) {
      numColumns += Math.ceil(numRemainingElements / numRows);
    } else if (numRows > numColumns) {
      numRows += Math.ceil(numRemainingElements / numColumns);
    } else {
      if (smartSelectGroup.getHeight() > smartSelectGroup.getWidth()) {
        numRows += Math.ceil(numRemainingElements / numColumns);
      } else {
        numColumns += Math.ceil(numRemainingElements / numRows);
      }
    }
  }

  return { numColumns, numRows };
}

export function getGrid (numRows, numColumns, gridWidth, gridHeight) {
  const cellWidth = Math.ceil(gridWidth / (numColumns - 1));
  const cellHeight = Math.ceil(gridHeight / (numRows - 1));

  const grid = [];
  for (let row = 0; row < numRows; row++) {
    grid[row] = [];
    for (let column = 0; column < numColumns; column++) {
      grid[row].push({ top: cellHeight * row, left: cellWidth * column, element: null });
    }
  }

  return { grid, cellWidth, cellHeight };
}

export function isEmpty (rowOrColumn) {
  return rowOrColumn.every((cell) => !cell.element);
}

export function fillElementToGrid ({ smartSelectGroup, grid, cellWidth, cellHeight }) {
  const numRows = grid.length;
  const numColumns = grid[0].length;
  const collidedElements = [];

  // fill up grid
  smartSelectGroup.getElements().forEach((element) => {
    const { row, column } = getRowColumn({
      element,
      cellWidth,
      cellHeight,
      topBorder: smartSelectGroup.getTopBorder(),
      leftBorder: smartSelectGroup.getLeftBorder()
    });

    if (!grid[row][column].element) {
      grid[row][column].element = element;
    } else {
      collidedElements.push(element);
    }
  });

  // filled up collided elements
  collidedElements.forEach((element) => {
    for (let row = 0; row < numRows; row++) {
      for (let column = 0; column < numColumns; column++) {
        if (!grid[row][column].element) {
          grid[row][column].element = element;
          return;
        }
      }
    }
  });

  return { grid, cellWidth, cellHeight, numRows, numColumns };
}
